<app-trains-modal #openTrain [modalTitle]="app.text.train.trains">
</app-trains-modal>

<!-- <app-modal
#deleteTrainModal
[modalMessage]="app.text.train.deleteMessage"
[modalTitle]="app.text.train.modalTitle"
(ok)="app.train.delete()"
></app-modal> -->

<div class="col-12 no-padding">
  <div class="control-bar">
    <button
      class="btn btn-control p-2"
      (click)="app.routing.navigateBack()"
      >
      <i class="far fa-arrow-left"></i> &nbsp; {{ app.text.app.backToCase }}
    </button>
  </div>
</div>

<div class="container-fluid">
  <button
    class="btn btn-sm btn-default-orange pull-right my-3"
    (click)="openTrain.open()"
    >
    <i class="fa fa-plus"></i>&nbsp; {{ app.text.app.add }}
  </button>

  <div>
    <div class="tableFixHead">
      <table class="table table-striped spacing-table">
        <thead>
          <tr>
            @for (column of app.list.train.trains; track column) {
              <th
                class="p-1 text-center"
                >
                <span
                (click)="
                  app.table.toggleSortDirection(column); app.table.sort(trains)
                "
                  >
                  {{ app.field.getLabel(column) }}
                </span>
                @if (column === app.table.sortField) {
                  <span>
                    @if (app.table.sortDirection === 1) {
                      <i
                        class="fa fa-chevron-up"
                      ></i>
                    }
                    @if (app.table.sortDirection === -1) {
                      <i
                        class="fa fa-chevron-down"
                      ></i>
                    }
                  </span>
                }
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (train of trains; track train; let i = $index) {
            <tr
              (click)="openTrain.open(train)"
              class="pointer"
              >
              @for (column of app.list.train.trains; track column) {
                <td
                  class="text-center"
                  >
                  @if (column !== 'impact.actions' && column !=='train.trainResponsible') {
                    <span>
                      {{ train[remove(column)] }}
                    </span>
                  }
                  @if (column === 'train.trainResponsible') {
                    <span>
                      {{app.users.getOptionName(train['trainResponsible'])}}
                    </span>
                  }
                  @if (
                    column === 'impact.actions' &&
                    app.permission.train.canAddTrainToCase
                    ) {
                    <span
                      class="pointer"
                (click)="
                  $event.stopPropagation();
                  app.train.delete(train);
                  removeItem(i)
                "
                      >
                      <i class="fa fa-trash"></i>
                    </span>
                  }
                </td>
              }
            </tr>
          }
          <tr>
            @if (loading) {
              <td colspan="99" class="text-center">
                {{ this.app.text.core.loading }}
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
